enum ActionTypes {
    RequestDotStates = "dotStates/request",
    AddDotStates = "dotStates/add",
    DotStatesError = "dotStates/error"
}

export default ActionTypes;
